<template>
  <div class="container" v-if="list.length>0">
    <div class="panel panel-default">
      <div class="panel-heading">
        <div class="category">
          <a class="category-top">天气预报</a>
          <a class="category-bottom">Weather forecast</a>
        </div>
      </div>
      <div class="tianqi">
        <!-- <div class="top">
          <span
            >{{ "[" + "三河古镇" + "]" }}
            <p>所在的天气</p></span
          >
        </div> -->
        <div class="center">
          <span class="box1">{{list[tianqiIndex].temperature}}</span>
          <span class="box2"
            >{{list[tianqiIndex].day_weather}}&nbsp;&nbsp;{{list[tianqiIndex].day_wind_direction+' '+list[tianqiIndex].day_wind_power}}&nbsp;&nbsp;{{list[tianqiIndex].air_temperature}}
            <br>
            <span v-if="list[tianqiIndex].pm2_5!=''">
              PM2.5值:&nbsp;
            <span
              class="tag"
              >{{list[tianqiIndex].pm2_5+' '+list[tianqiIndex].quality}}</span>
            </span>
              </span>
          <span class="box3">{{list[tianqiIndex].weekday+'/'+list[tianqiIndex].day}}</span>
        </div>
        <div class="footer">
          <img class="toleft" src="@/assets/images/tianqieft.png" alt="" />
          <img class="toright" src="@/assets/images/tianqieft.png" alt="" />
          <!-- <div class="more">《 向左滑动更多</div> -->
          <van-swipe :show-indicators="false" :loop="false" :width="80">
            <van-swipe-item
              v-for="(item, index) in list"
              :key="index"
              @click="swiperCilck(item, index)"
            >
              <div
                class="tianqidetail"
                :class="tianqiIndex == index ? 'actived' : ''"
              >
                <span>{{item.weekday}}</span>
                <span>{{item.day}}</span>
                <img
                  :src="item.day_weather_pic"
                  alt=""
                />
                <span>{{item.day_weather}}</span>
                <span>{{item.air_temperature}}</span>
              </div>
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: false,
      tianqiIndex: 0,
    };
  },
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
    name: {
  		type: String,
  		default: '天气预报'
  	},
  },
  components: {},
  mounted: function () {},
  methods: {
    swiperCilck(item, index) {
      // console.log(item);
      this.tianqiIndex = index;
    },
  },
};
</script>
<style scoped>
.tianqi {
  width: 100%;
  height: 190px;
  /* background: url("../../assets/images/tianqi.png") no-repeat; */
  /* background: #ffe4db; */
  background-size: 100%;
  position: relative;
}
.tianqi .footer {
  position: absolute;
  height: 122px;
  bottom: 6px;
  left: 0px;
  right: 0px;
  padding: 0 20px;
}
.tianqi .footer .van-swipe {
  height: 120px;
  border-radius: 0px;
}
.tianqidetail {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #000;
  height: 100%;
}
.actived {
  background-image: linear-gradient(rgba(255, 228, 219), rgba(255, 228, 219));
}
.tianqidetail span {
  margin-bottom: 4px;
}
.tianqidetail img {
  width: 30px;
  height: 30px;
  display: block;
}
.top {
  height: 40px;
  color: #000;
}
.top span {
  width: 100%;
  display: flex;
  padding-left: 10px;
}
.top span p {
  color: #000;
  margin-left: 3%;
}
.center {
  padding: 6px 10px;
  display: flex;
  color: #000;
  position: relative;
}
.box1 {
  font-size: 26px;
}
.box2 {
  display: inline-block;
  /* max-width: 160px; */
  font-size: 12px;
  margin-left: 3%;
  line-height: 18px;
}
.box2 .tag {
  background: #f8cc47;
  padding: 1px 4px;
}
.box3 {
  position: absolute;
  top: 6px;
  right: 10px;
  font-size: 12px;
}
.more {
  position: absolute;
  right: 0;
  transform: translateY(-100%);
  color: #000;
  /* 执行时间 */
  animation: myfirst 1s;
  -webkit-animation: myfirst 1s; /* Safari and Chrome */
  /* 重复播放 */
  animation-iteration-count: infinite;
  /* 匀速播放 */
  animation-timing-function: linear;
  /* 先执行一遍动画，然后再反向执行一遍动画： */
  animation-direction: alternate;
  -webkit-animation-direction: alternate; /* Safari 和 Chrome */
}
@keyframes myfirst {
  0% {
    right: 0px;
  }
  100% {
    right: 20px;
  }
}

@-webkit-keyframes myfirst /* Safari and Chrome */ {
  0% {
    right: 0px;
  }
  100% {
    right: 10px;
  }
}
.toleft {
  width: 20px;
  height: 26px;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}
.toright {
  width: 20px;
  height: 26px;
  position: absolute;
  right: 0;
  top: 38%;
  transform: rotate(180deg);
  -ms-transform: rotate(180deg); /* IE 9 */
  -moz-transform: rotate(180deg); /* Firefox */
  -webkit-transform: rotate(180deg); /* Safari 和 Chrome */
  -o-transform: rotate(180deg); /* Opera */
}
</style>